import type { filtersType } from '../../../components/v2/filters/interfaces'

export const getFilters = ({ currentFilters, availableFilters, isLeader }): filtersType[] => {
  const topFilters = [
    {
      name: 'customer_name',
      label: 'Контактное лицо клиента',
      placeholder: 'Контактное лицо клиента',
      type: 'input-string',
      value: currentFilters?.customer_name,
      options: { width: '170px' },
    },
    {
      name: 'phone',
      label: 'Телефон клиента',
      type: 'phone',
      value: currentFilters?.phone,
    },
  ]

  const baseFilters = [
    {
      name: 'id',
      label: 'Найти заказ',
      placeholder: 'Найти заказ',
      prefix: 'ID',
      type: 'input-integer',
      value: currentFilters?.id,
      options: { width: '170px' },
    },
    /*{
      name: 'stage',
      label: 'Фильтр по стадии',
      placeholder: 'Выберите стадию',
      type: 'select_multiple',
      value: Array.isArray(currentFilters?.stage) ? currentFilters.stage.join(',') : currentFilters?.stage,
      options: { enum: availableFilters?.stage || [] },
    },*/
    {
      name: 'production_number',
      label: 'Номер производственного заказа',
      placeholder: 'Номер производственного заказа',
      type: 'input-string',
      value: currentFilters?.production_number,
      options: { width: '170px' },
    },
  ]

  const drawerFilters = [
    {
      name: 'manager',
      label: 'Менеджер',
      placeholder: 'Выберите менеджера',
      type: 'select',
      value: currentFilters?.manager ? Number(currentFilters?.manager) : undefined,
      options: { enum: availableFilters?.manager },
    },
    {
      type: 'filter_group',
      name: '_',
      label: 'Дата',
      items: [
        {
          name: 'dates_range',
          label: 'Диапазон дат',
          type: 'dates',
          value: currentFilters?.dates_range,
        },
        {
          name: 'dates_field',
          label: 'Поле даты',
          type: 'select',
          value: currentFilters.dates_field || 'appeal',
          options: {
            allowClear: false,
            enum: [
              { label: 'Дата обращения', value: 'appeal' },
              { label: 'Дата заказа', value: 'created_at' },
              { label: 'Дата замера', value: 'measurement' },
              { label: 'Дата предоплаты', value: 'prepayment' },
              { label: 'Дата окончательной оплаты', value: 'repayment' },
              { label: 'Дата доставки', value: 'shipping' },
              { label: 'Дата монтажа', value: 'mounting' },
              { label: 'Дата задачи', value: 'task' },
            ],
          },
        },
      ],
    },
    {
      name: 'cancel_reason',
      label: 'Причина отмены',
      placeholder: 'Выберите причину',
      type: 'select',
      value: currentFilters?.cancel_reason ? Number(currentFilters.cancel_reason) : undefined,
      options: { enum: availableFilters?.cancel_reason || [] },
    },
    {
      name: 'order_attribute',
      label: 'Признак заказа',
      placeholder: 'Выберите признак',
      type: 'select',
      value: currentFilters?.order_attribute ? Number(currentFilters.order_attribute) : undefined,
      options: { enum: availableFilters?.order_attribute || [] },
    },
  ]

  if (isLeader) {
    drawerFilters.push({
      name: 'brand',
      label: 'Бренд',
      placeholder: 'Выберите бренд',
      type: 'select',
      value: currentFilters?.brand ? Number(currentFilters?.brand) : undefined,
      options: { enum: availableFilters?.brand || [] },
    })
    drawerFilters.push({
      name: 'office',
      label: 'Офис',
      placeholder: 'Выберите офис',
      type: 'select',
      value: currentFilters?.office ? Number(currentFilters?.office) : undefined,
      options: { enum: availableFilters?.office || [] },
    })
  }

  return [...topFilters, ...baseFilters, ...drawerFilters] as filtersType[]
}
